import React, {useCallback} from 'react';
import {isTextSearchFilterTabActive} from '../ParticipantsTabs/TextSearchParticipants/isTextSearchFilterTabActive';
import SearchBar from '../../../../elements/SearchBar/SearchBar3';
import {useDispatch} from 'react-redux';

function ParticipantsTextSearch(props) {
    const {eventId, filterParams} = props,
        dispatch = useDispatch();

    const handleTextFilterChange = useCallback(text => dispatch(app.actions.participants.filterByText(eventId, text)), [eventId]);

    if (!isTextSearchFilterTabActive(filterParams)) return null;

    return <SearchBar value={filterParams?.text ?? ''} onTextChange={handleTextFilterChange} autoFocus />;
}

export default ParticipantsTextSearch;
